import { render, staticRenderFns } from "./VIPDowngradeModal.vue?vue&type=template&id=f3cd3010&scoped=true"
import script from "./VIPDowngradeModal.vue?vue&type=script&lang=js"
export * from "./VIPDowngradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cd3010",
  null
  
)

export default component.exports